import { render, staticRenderFns } from "./TermsView.vue?vue&type=template&id=2ef4a8b6&scoped=true"
import script from "./TermsView.vue?vue&type=script&lang=ts"
export * from "./TermsView.vue?vue&type=script&lang=ts"
import style0 from "./TermsView.vue?vue&type=style&index=0&id=2ef4a8b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4a8b6",
  null
  
)

export default component.exports